import React, { useRef } from 'react';
import RagnaDataTable from '../ReactComponents/RagnaDataTable.jsx'; 
import axios from 'axios';
import { ajax_api, createArrayWithLength, getAccess } from '../../Globals.jsx';
import { useOutlet, Outlet, useOutletContext } from 'react-router-dom';
import { Helmet } from 'react-helmet';

const FtpLocations = _ => {
    //datatable options
    const [refreshTable] = useOutletContext();
    const table_columns = [
        { display: "ID", col: "Id" },
        { display: "Name", col: "label" },
        { display: "Host", col: "host" },
        { display: "Port", col: "port" },
        { display: "Username", col: "username" },
        //{ display: "Password", col: "password" },
        { display: "Priority Order", col: "priority_order" },
        { display: "Is Active", col: "is_active", customValue: d => d.is_active ? "Yes" : "No" }
    ];
    const search_columns = [
        { display: "Name", col: "label" }
    ];
    const outlet = useOutlet();
    const ftpLabel = useRef(null);
    const ftpHost = useRef(null);
    const ftpPort = useRef(null);
    const ftpUName = useRef(null);
    const ftpPw = useRef(null);
    const ftpPrio = useRef(null);
    const fptIsActive = useRef(null);
    
    return <>
        <Helmet>
            <title>LTS | Manage FTP Locations</title>
        </Helmet>
        {
            outlet != null ? <Outlet /> :
                <RagnaDataTable
                    refreshTable={refreshTable}
                    title="Ftp Locations"
                    columns={table_columns}
                    s_columns={search_columns}
                    defaultOrder={false}
                    maxPagination={8}
                    generalSearch={true}
                    defaultOrderCol="ID"
                    url={ajax_api+"ftp/ftp-locations/get"}
                    actions={[
                        {
                            hideIf: !getAccess(94),
                            action: "modal", display: "Edit",
                            body: d => <>
                            <div>
                                Name: <input ref={ftpLabel} className="form-control" defaultValue={d.label} key={"ftploc-label-"+d.Id} />
                            </div>
                            <div>
                                Host: <input ref={ftpHost} className="form-control" defaultValue={d.host} key={"ftploc-host-"+d.Id} />
                            </div>
                            <div>
                                Port: <input ref={ftpPort} className="form-control" defaultValue={d.port} key={"ftploc-port-"+d.Id} />
                            </div>
                            <div>
                                Username: <input ref={ftpUName} className="form-control" defaultValue={d.username} key={"ftploc-uname-"+d.Id} />
                            </div>
                            <div>
                                Password: <input ref={ftpPw} type="password" className="form-control" defaultValue={d.password} key={"ftploc-pw-"+d.Id} />
                            </div>
                            <div>
                                Priority Order: <select ref={ftpPrio} className="form-control" defaultValue={d.priority_order} key={"ftploc-order-"+d.Id}>
                                    {
                                        createArrayWithLength(100).map(o=><option>{o}</option>)
                                    }
                                </select>
                            </div>
                            <div>
                                Is Active: <input ref={fptIsActive} type="checkbox" defaultChecked={d.is_active} key={"ftploc-active-"+d.Id} />
                            </div>
                            </>, title: "Edit Data",
                            footer: (d, mOpen, refresh) => <button className="ro-button" onClick={_ => {
                                var form_data = new FormData();

                                form_data.append("label", ftpLabel.current.value);
                                form_data.append("host", ftpHost.current.value);
                                form_data.append("port", ftpPort.current.value);
                                form_data.append("username", ftpUName.current.value);
                                form_data.append("priority_order", ftpPrio.current.value);
                                form_data.append("is_active", fptIsActive.current.checked);
                                form_data.append("password", ftpPw.current.value);
                                form_data.append("Id", d.Id);

                                axios.post(`${ajax_api}ftp/ftp-locations/edit`, form_data, {
                                    withCredentials: true
                                }).then(_ => {
                                    mOpen(false);
                                    refresh();
                                }).catch(e=>alert(e))
                            }}>
                                <span>Save</span>
                            </button>
                        },
                        {
                            hideIf: !getAccess(95),
                            action: "url_confirm", display: "Delete",
                            content: d => `${ajax_api}ftp/ftp-locations/delete/${d.Id}`,
                            body: d => `Are you sure you want to delete this FTP Location named "${d.label}" ?`, title: "Delete Data"
                        },
                        //{
                        //    action: "modal", display: "Cust",
                        //    content: d => { return { title: "title modal", body: "full name: " + d.full_name, footer: <span>footer</span> } }
                        //},
                    ]}
                />
        }
    </>
}

export default FtpLocations;